import {API_HOST, catchError, AXIOS_INSTANCE} from './api'

export async function REQUEST_FORM(payload) {
    try {
        const response = await AXIOS_INSTANCE.post(`${API_HOST}/form/request`, payload,
        {
            headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
            }
        });
        return response.data;
    } catch (e) {
        catchError(e);
    }
}


// WEBPACK FOOTER //
// ./src/services/formBuilder.js